import { delay, getWhatId, getExternalUuid, getStoredLocation, parseAbQuery, checkReachGoalReady, modifyData, ensureVariantCookie, isTelegramBrowser } from "@utils";
import { action, observable, makeObservable, toJS } from "mobx";
import ym from "react-yandex-metrika";
import { _getByUrl, _postByUrl, _putByUrl, _deleteByUrl, _initServiceAfterAuth } from "./service";
import tracker from "./tracker";
import { getErrorStatus, getToastMessage } from "../helpers/apiError";
import { getDuplicateOfferDetails, normalizeOfferId, prepareDuplicateOfferRequest } from "../helpers/duplicateOffers";

const { VITE_WHAT_ID, VITE_ASSETS_URL, VITE_NODE_ENV, VITE_RIS_METRICA_URL, VITE_API_URL } = import.meta.env;

const DELAYLOADER = 100;

class MainStore {
    // _initStorePromise = null;
    // _realPageEntryPromise = null;

    mainStore = {
        initialApp: "notCompleted", // loading, complete
        preload_data: { preloadWheel: [] },
        loader: false,
        notification: false,
        modal: false,
        captcha: false,
        capToken: "qwerty",
        init: false,
        locationData: false,
        userLocation: false,
        offersList: false,
        abTest: {}, // Инициализируем пустым объектом
        isStart: false,
        isVisible: false,
        cookieConsent: false,
        getPromoUrl: false,
        newGetPromoUrl: "", // базовый адрес API только для get_promo (_n_g_p из /initial), "" - используем старую ручку
        visibleItems: 5,
        isCoverRoot: true, //удалить как в ios26 пофиксят прозрачность полосок браузера
        offerCategories: [],
        offersByCategory: new Map(),
        selectedOfferCategory: null,
        formQuestionsChain: [],
        form_questions: {},
        indexPositionMetric: null,
        settingLego: {
            bgColor: "default",
            ctaColor: "default",
            queueDuration: 5,
            queueRandomness: true,
            isPartnerHeaderVariant: true,
        },
    };

    constructor(props) {
        makeObservable(this, {
            mainStore: observable,
            setMainStore: action,
        });
    }

    // waitForRealPageEntry = async () => {
    //     if (typeof window === "undefined" || typeof document === "undefined") return;

    //     if (this._realPageEntryPromise) return this._realPageEntryPromise;

    //     this._realPageEntryPromise = new Promise((resolve) => {
    //         const waitVisible = () => {
    //             if (document.visibilityState === "visible") {
    //                 resolve();
    //                 return;
    //             }

    //             const onVisibilityChange = () => {
    //                 if (document.visibilityState === "visible") {
    //                     document.removeEventListener("visibilitychange", onVisibilityChange);
    //                     resolve();
    //                 }
    //             };

    //             document.addEventListener("visibilitychange", onVisibilityChange);
    //         };

    //         if (document.prerendering) {
    //             console.log("Страница в prerendering. Откладываем initStore до реального входа.");

    //             document.addEventListener(
    //                 "prerenderingchange",
    //                 () => {
    //                     console.log("Страница активирована после prerendering.");
    //                     waitVisible();
    //                 },
    //                 { once: true },
    //             );

    //             return;
    //         }

    //         waitVisible();
    //     });

    //     return this._realPageEntryPromise;
    // };

    // initStore = async () => {
    //     if (this._initStorePromise) return this._initStorePromise;

    //     this._initStorePromise = this._initStoreInternal();

    //     return this._initStorePromise;
    // };

    // _initStoreInternal = async () => {
    initStore = async () => {
        console.log("init store");

        document.documentElement.classList.toggle("telegram-browser", isTelegramBrowser());

        // проверяем на лишние параметры в урл, если есть выводим страницу 404
        const exludeParams = ["documents", "promotion"];
        const params = window?.location?.pathname?.split("/");
        const firstParam = params?.[1] || false;
        const parsedAB = parseAbQuery();

        // Проверяем, является ли первый параметр фич-веткой (DEV-{number})
        const isFeatureBranch = firstParam && /^DEV-\d+$/.test(firstParam);

        if (isFeatureBranch) console.log("🔧 Фич-ветка обнаружена:", firstParam);

        const isNotFound = firstParam ? !exludeParams.includes(firstParam) && !isFeatureBranch : false; // если первого параметра нет в исключениях и это не фич-ветка

        if (isNotFound) {
            this.setMainStore("initialApp", "complete"); //пускаем на роутер который уже дальше выдаст 404
            return;
        }
        // проверяем на лишние параметры в урл, если есть останавливаем инит и выводим страницу 404

        // не делаем запрос на инит, если есть в исключениях при которых не нужны дальнейшие запросы
        if (firstParam && exludeParams.includes(firstParam)) {
            console.log("📄 Документы - пропускаем инициализацию");
            this.setMainStore("initialApp", "complete");
            return;
        }
        // не делаем запрос на инит, если есть в исключениях при которых не нужны дальнейшие запросы

        // await this.waitForRealPageEntry();
        const variant = await ensureVariantCookie();

        const searchParams = new URLSearchParams(window?.location?.search);
        const offerId = searchParams.get("id"); // айдишка офера в ссылке
        const em_hash = searchParams.get("em_hash");
        let utmParams = {};
        const utmString = new URLSearchParams();

        for (const [key, value] of searchParams) {
            if (key.startsWith("utm_")) {
                if (value.length) {
                    utmParams[key] = value;
                    utmString.append(key, value);
                } else {
                    utmParams = {};
                }
            }
        }

        const _ym_uid =
            document.cookie
                .split("; ")
                .find((row) => row.startsWith("_ym_uid="))
                ?.split("=")[1] || "";

        let gender = "";
        let age = "";
        let utmCampaignData = false;
        let utmCampaign = false;

        console.log("utmParams", utmParams);

        if (Object.keys(utmParams).length) {
            utmCampaign = utmParams?.utm_campaign?.split("|");
            utmCampaignData = utmCampaign && utmCampaign[0] ? utmCampaign[0].split("_") : "";
            gender = utmCampaignData[0] === "Male" || utmCampaignData[0] === "Fem" || utmCampaignData[0] === "Female" ? utmCampaignData[0] : "";
            age = utmCampaignData && utmCampaignData[1]?.includes("-") && /^\d+-\d+$/.test(utmCampaignData[1]) ? utmCampaignData[1] : "";
        }

        const now = new Date();

        function getDeviceType() {
            const userAgent = navigator.userAgent;

            if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())) {
                if (/ipad|android(?!.*mobile)|tablet/i.test(userAgent)) {
                    return "tablet";
                }
                return "mobile";
            }

            return "desktop";
        }

        const weekday = now.toLocaleDateString("en-US", { weekday: "long" });
        const ua = navigator.userAgent;
        let platform = "";

        if (/iPad|iPhone|iPod/.test(ua)) {
            platform = "iOS";
        } else if (/Mac/.test(ua)) {
            platform = "macOS";
        } else if (/Win/.test(ua)) {
            platform = "Windows";
        } else if (/Android/.test(ua)) {
            platform = "Android";
        } else if (/Linux/.test(ua)) {
            platform = "Linux";
        }

        const dataUser = {
            ym_uid: _ym_uid,
            from_partner: Object.keys(utmParams).length && utmParams.utm_source ? utmParams.utm_source.trim() : "",
            transition_type: utmCampaign ? utmCampaign[utmCampaign.length - 1].trim() : "",
            device_platform: platform,
            device_type: getDeviceType(),
            device_screen: `${window.innerWidth}:${window.innerHeight}`,
            week_day: weekday,
            gender: gender || "",
            age: age || "",
            utm_in: utmString ? utmString.toString() : "",
            fullQueryParams: searchParams?.toString(),
            // platform: navigator.userAgentData.platform,
            // typeDevice: getDeviceType(),
            // screen: `${window.innerWidth}:${window.innerHeight}`,
            // partner: Object.keys(utmParams).length ? utmParams.utm_source : '',
            // typeTransition: utmCampaign ? utmCampaign[utmCampaign.length - 1] : null,
            // timeOfDay: timeOfDay,
            // weekDay: weekday,
            // gender: gender || "",
            // age: age || "",
        };

        console.log("~ MainStore ~ dataUser:", dataUser);
        console.log("🚀 Начинаем инициализацию приложения...");

        const init = await this.postByUrl("/app_rispromo_init/initial", { _ym_uid: _ym_uid, em_hash: em_hash, u_data: dataUser, ...parsedAB }, true, false, "init", false);
        if (init && init.success && init.data) {
            console.log("✅ Инициализация успешна:", init);

            tracker._initTracker({
                counter: "g9Swn4hE5Y",
                // domain: init && init.data && init.data._p_tr ? init.data._p_tr : VITE_RIS_METRICA_URL,
                domain: VITE_RIS_METRICA_URL,
                rps: localStorage.getItem("_r_p_s"),
                isDuplicatedOffer: (offerId) => {
                    const offersList = this.mainStore.offersList;
                    const offers = [...(offersList?.offers || []), ...(offersList?.promo || [])];

                    return offers.some((offer) => offer?._id === offerId && offer?._is_dplc === true);
                },
                getDuplicateOfferDetails: (offerId) => getDuplicateOfferDetails(offerId, this.mainStore.offersList?.offers || []),
            });

            this.setMainStore("init", init);
            this.setMainStore("initialApp", "loading");

            const customColors = init?.data?._theme;

            this.setMainStore("customThemeTitle", customColors?.title);

            const colorMapping = {
                primary: "--color1",
                secondary: "--color2",
                thirdly: "--color7",
            };

            if (customColors) {
                Object.entries(colorMapping).forEach(([key, cssVar]) => {
                    const value = customColors[key];
                    if (value) {
                        document.documentElement.style.setProperty(cssVar, value);
                    }
                });
            }

            let siteTheme = false;
            if (init.data && init.data._ab_m && Object.values(init.data._ab_m).length) {
                let dataTest = {};
                let dataNameTest = false;
                for (let prop in init.data._ab_m) {
                    if (init.data._ab_m[prop] && init.data._ab_m[prop]._d) {
                        dataTest = { ...dataTest, ...init.data._ab_m[prop]._d };
                        dataNameTest = init.data._ab_m[prop]._d.metrikaKey;
                        siteTheme = init.data._ab_m[prop]._d.siteTheme;
                    }
                }

                this.setMainStore(`test`, dataTest);
                this.setMainStore("abTestMetika", dataNameTest);
            }

            // Для контрольных вариантов этой витрины сохраняем отдельную тему после initial.
            const whatId = getWhatId() || VITE_WHAT_ID;
            const isControlVariant = whatId === "6a4775c61c369911758ae556" && ["main", "product"].includes(variant);
            const theme = isControlVariant ? "ab-control" : siteTheme || init?.data?._p_t || "default";
            this.setMainStore(`theme`, theme);
            document.documentElement.dataset.theme = theme;

            const wdCd = init?.data?._w_d?._cd;
            const cdPrefix = typeof wdCd === "string" ? wdCd.split("_")[0] : "";
            const cdConfig = init?.data?._w_d?.config;
            const wdm = init?.data?._w_d_m ? init?.data?._w_d_m : "";
            const wd_mc = init?.data?._w_d?._m_c ? init?.data?._w_d?._m_c : "";
            const getPromoUrl = init?.data?._p_g_p ? init?.data?._p_g_p : false;
            const newGetPromoUrl = typeof init?.data?._n_g_p === "string" ? init.data._n_g_p : "";
            const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
            const urlParams = new URLSearchParams(window.location.search);
            const disableMetrika = urlParams.has("noym");

            if (!disableMetrika) {
                try {
                    const externalUuid = getExternalUuid();
                    const abTestMetika = this.getMainStore("abTestMetika");
                    const metrikaKey = abTestMetika || "ris_promo";
                    ym("reachGoal", `entry`, { reachGoal: { [metrikaKey]: { ["entry"]: { null: { null: { null: { null: { [wdCd ? wdCd : null]: what_id } } } } } } } });

                    checkReachGoalReady()
                        .then(() => {
                            window.risMetrika.reachgoal_ch({
                                event: "entry",
                                siteId: what_id,
                                session_uuid: localStorage.getItem("_r_p_s"),
                                widget_code: wdCd ? wdCd : "",
                                ml_traffic_mode: wdm,
                                ml_model_code: wd_mc,
                                additional_property: externalUuid ? { external_id: externalUuid } : "",
                            });
                        })
                        .catch((error) => {
                            console.error("Не удалось загрузить reachgoal_ch:", error);
                        });
                } catch (error) {
                    console.warn("Ошибка при отправке метрики:", error);
                }
            }

            const MODAL_MAP = {
                ai: "ai",
                face: "face",
                koleso: "koleso",
                categoria: "ai",

                //грузим модалки в разных комбинациях
                base: "ava-wheel",
                base1: "ava-wheel",
                base2: "fortune",
                base3: "empty", // просто заглушка. при base3 ничего не показываем, сразу витрина
                base4: "ava-wheel",
                //грузим модалки в разных комбинациях
            };

            const modalType = MODAL_MAP[cdPrefix] ?? "ava-wheel";

            this.setMainStore("settingLego", cdConfig);
            this.setMainStore("codeTypeMetrika", wdCd);
            this.setMainStore("codeWdm", wdm);
            this.setMainStore("codeWdMc", wd_mc);
            this.setMainStore("getPromoUrl", getPromoUrl);
            this.setMainStore("newGetPromoUrl", newGetPromoUrl);

            if (modalType && !offerId && !em_hash && !["base3"].includes(cdPrefix)) {
                const preload_app = await this.getByUrl("/app_rispromo_init/preload_app", "", false, "", false);
                if (preload_app?.success && preload_app?.data) {
                    console.log("🚀 preload_app OK");
                    this.setMainStore("preload_data", preload_app.data);
                }

                this.setMainStore("initialApp", "complete");
                this.setMainStore("isStart", true);
                this.setMainStore("modal", { type: modalType, cdPrefix }); // включаем первую модалку колеса если нет offerId
                await delay(0);
            } else {
                this.setMainStore("isCoverRoot", false); //удалить как в ios26 пофиксят прозрачность полосок браузера
                this.setMainStore("isVisible", true);
            }

            if (init.data._uu) {
                localStorage.setItem("_uuid_rispromo", init.data._uu);
            }

            // запись и обновление в headers токена
            const token = init?.data._t || "";
            localStorage.setItem("token", token);
            _initServiceAfterAuth(token);

            await this.getByUrl("app_rispromo_user/user_locations", {}, true, "userLocation", false, false);

            // костыль для проверки метода
            window.testLocation = (coords = "") => this.getByUrl("/app_rispromo_user/user_locations", coords, false, "userLocation", "", false);
            // костыль для проверки метода

            // получение офферов ддя дальнейшей отрисовки колеса фортуны и списка офферов

            this.setMainStore("initialApp", "complete"); // init done

            const region = await this.getByUrl("/app_rispromo_supply/locations", "", false, "locationData", false);
            if (region?.success && Array.isArray(region.data)) {
                const city = [];
                const metro = [];

                region.data.forEach((el) => {
                    if (el && el.cities && Array.isArray(el.cities) && el.cities.length) {
                        if (el.name === "Москва" || el.name === "Санкт-Петербург") {
                            city.push([{ ...el.cities[0], metro: el.metro }]);
                        } else {
                            city.push(el.cities);
                        }

                        el.cities.forEach((elMetro) => {
                            if (elMetro && elMetro.metro && Array.isArray(elMetro.metro) && elMetro.metro.length) {
                                metro.push(elMetro.metro);
                            }
                        });
                    }
                    if (el && el.metro && Array.isArray(el.metro) && el.metro.length) {
                        metro.push(el.metro);
                        const obj = { ...el, cities: [], cityReg: el.name };
                        city.push({ ...obj, metro: el.metro });
                    }
                });

                this.setMainStore("citiesData", city.flat());
                this.setMainStore("metroData", metro.flat());
            }

            const getOffer = async () => {
                const offersList = await this.getByUrl("/app_rispromo/offers_list", { ...parsedAB, offerId: offerId || "" }, false, "", false);
                let apdated = null;
                if (offersList && offersList.success && offersList.data) {
                    const questions = await this.getByUrl("app_rispromo/form_questions", "", false, "", false);
                    if (questions?.success && questions?.data?.length) this.setMainStore("form_questions", modifyData(questions.data, "_id"));

                    const offers = offersList.data || null;
                    if (offers?.promo) {
                        apdated = this.updateOffers(offers, ["promoCode", "cdn", "activationLink"]); //апдейт офферов, меняем пути всех картинок с yandex на cdn
                        this.setMainStore("offersList", apdated);
                    }

                    //  AB_3632
                    const categoriesEnabled = ["dev_3632"].some((code) => init?.data?._ab_m?.[code]?._d?.colorHeader === "v2");

                    if (categoriesEnabled) {
                        this.setOffersByCategory(apdated || offers);
                    }
                    // AB_3632

                    // Безопасная проверка _ab_m
                    if (offersList.data._ab_m) {
                        this.setMainStore("abTest", offersList.data._ab_m);
                    } else {
                        // Устанавливаем пустой объект, если _ab_m отсутствует
                        this.setMainStore("abTest", {});
                    }
                }
            };

            const storedLocation = getStoredLocation();

            if (!storedLocation && localStorage.getItem("locale_ris_promo")) {
                localStorage.removeItem("locale_ris_promo");
                localStorage.removeItem("locale_ris_promo_source");
            }

            await getOffer();

            this.setMainStore("initialApp", "complete"); // init done
        }
    };

    getByUrl = async (url, params = "", reqHeaders = false, key = "", loader = true, change_url = { baseURL: VITE_API_URL }) => {
        loader && this.setMainStore("loader", true);
        const requestParams = prepareDuplicateOfferRequest(url, params, this.mainStore.offersList?.offers || []);
        const service = await _getByUrl(url, requestParams, reqHeaders, change_url);
        if (service?.success && /^\/?app_rispromo\/get_promo\/?$/.test(url) && requestParams?.isDuplicated === true) {
            const pageUrl = new URL(window.location.href);
            // Keep a claimed copy's link valid when the next list no longer contains that copy.
            if (pageUrl.searchParams.get("id") === params.offerId && params.offerId !== requestParams.offerId) {
                pageUrl.searchParams.set("id", requestParams.offerId);
                window.history.replaceState(window.history.state, "", pageUrl.toString());
            }
        }
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: getToastMessage(service) });
        } else if (key) {
            this.setMainStore(key, service.data);
        }

        return service;
    };

    postByUrl = async (url, params = "", cda, reqHeaders = false, key = "", loader = true) => {
        loader && this.setMainStore("loader", true);
        const service = await _postByUrl(url, params, cda);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        console.log("key", key);
        console.log("service", service);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: getToastMessage(service) });
        } else if (key) {
            console.log(key, service.data);

            this.setMainStore(key, service.data);
        }

        return service;
    };

    putByUrl = async (url, params = "", reqHeaders = false, key = "", loader = true) => {
        loader && this.setMainStore("loader", true);
        const service = await _putByUrl(url, params);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: getToastMessage(service) });
        } else if (key) {
            this.setMainStore(key, service.data);
        }

        return service;
    };

    deleteByUrl = async (url, params = "", reqHeaders = false, key = "", loader = true) => {
        loader && this.setMainStore("loader", true);
        const service = await _deleteByUrl(url);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: getToastMessage(service) });
        } else if (key) {
            this.setMainStore(key, service.data);
        }

        return service;
    };

    getMainStore = (key) => {
        if (typeof this.mainStore[key] === "undefined") {
            return false;
        } else {
            return toJS(this.mainStore[key]);
        }
    };

    setMainStore = (key, value) => {
        this.mainStore[key] = value;
    };

    checkErrorCode = (service) => {
        const code = getErrorStatus(service) || 0;
        console.log("checkErrorCode", code);

        switch (code) {
            // Ограничитель частоты и исчерпанный дневной лимит выдачи приходят
            // с одним статусом, развести их можно только по errorCode из тела
            case 429:
                console.log("is captcha");
                // this.setMainStore("captcha", true);
                break;

            default:
                break;
        }
    };

    updateOffers = (obj = {}, updtateArr = []) => {
        if (Array.isArray(obj.offers) && Array.isArray(obj.promo)) {
            const usedIds = new Set();
            const allOffers = [...obj.offers, ...obj.promo];

            allOffers.forEach((offer) => {
                if (!offer?._id) return;

                const originalId = offer._id;
                let nextId = originalId;
                let version = 2;

                while (usedIds.has(nextId)) {
                    nextId = `${originalId}_v${version}`;
                    version += 1;
                }

                offer._id = nextId;
                if (nextId !== originalId) {
                    offer._is_dplc = true;
                }
                usedIds.add(nextId);
            });
        }

        updtateArr.forEach((key) => {
            const codes = { promoCode: "code" }; // исключения, потому что названия ключей не совпадают в offer_item promo с offer_item offers
            switch (key) {
                case "promoCode":
                case "activationLink":
                    if (Array.isArray(obj.offers) && Array.isArray(obj.promo)) {
                        obj.promo.reduce((acc, row) => {
                            const targetOfferId = normalizeOfferId(row._uiOfferId || row.offerId);

                            for (let i = 0; i < acc.offers.length; i++) {
                                const offerId = acc.offers?.[i]?._id;
                                const isCurrentOffer = normalizeOfferId(offerId) == targetOfferId;

                                if (isCurrentOffer) {
                                    const codeAdapter = codes[key] ?? key; // если нет ключа из промо для адаптирования под оффер, то оставляем дефолтный key
                                    acc.offers[i][key] = row[codeAdapter];
                                }
                            }
                            return acc;
                        }, obj);
                    }
                    break;
                case "cdn":
                    // eslint-disable-next-line no-case-declarations
                    const envs = {
                        development: /https:\/\/storage.yandexcloud.net\/rp-dev-assets/i,
                        staging: /https:\/\/storage.yandexcloud.net\/rp-prod-assets/i,
                        production: /https:\/\/storage.yandexcloud.net\/rp-prod-assets/i,
                    };

                    obj.offers.reduce((acc, row) => {
                        Object.entries(row.vendor).forEach(([vKey, val]) => {
                            if (typeof val == "string" && val.match(envs[VITE_NODE_ENV])) {
                                const str = val.replace(envs[VITE_NODE_ENV], VITE_ASSETS_URL);
                                row.vendor[vKey] = str;
                            }
                        });
                        return acc;
                    }, obj);
                    break;

                default:
                    break;
            }
        });

        return obj;
    };

    setOffersByCategory = (offersList) => {
        const categories = [];
        const offersByCategory = new Map();
        const seen = new Set();

        offersByCategory.set("all", offersList);

        (offersList?.offers || []).forEach((offer) => {
            (offer.categories || offer.vendorcategories || []).forEach((category) => {
                const { alias } = category;

                if (!alias) return;

                if (!seen.has(alias)) {
                    seen.add(alias);
                    categories.push(category);
                    offersByCategory.set(alias, []);
                }

                offersByCategory.get(alias).push(offer);
            });
        });

        this.setMainStore("offerCategories", categories);
        this.setMainStore("offersByCategory", offersByCategory);
    };

    addPromoToOffer = (obj = {}, uiOfferId = "") => {
        const offersList = this.getMainStore("offersList");
        offersList.promo.push(uiOfferId ? { ...obj, _uiOfferId: uiOfferId } : obj);
        const adapted = this.updateOffers(offersList, ["promoCode", "activationLink"]);
        this.setMainStore("offersList", adapted);

        const offersByCategory = this.getMainStore("offersByCategory");
        if (offersByCategory instanceof Map && offersByCategory.size) {
            this.setOffersByCategory(adapted);
        }

        return adapted;
    };
}

export default new MainStore();
